import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAncptMarginData } from "src/api/bi";
import { BarChartsInitialState } from "../../interface";
import stringToNumber from "src/utils/stringToNumber";
import { filterByDepartment } from "../../utils";
import { resetStore } from "src/store/actions";

export const fetchAncptMarginData = createAsyncThunk(
  "dashboard/fetchAncptMarginData",
  ({
    storeId,
    fromDate,
    toDate,
    _department,
    departmentId
  }: {
    storeId: string;
    fromDate: string;
    toDate: string;
    _department?: string;
    departmentId: string;
  }) => getAncptMarginData({ fromDate, toDate, storeId })
);

const initialState: BarChartsInitialState = {
  data: [],
  status: "idle",
  error: "",
  currentPage: 1,
  totalPages: 10,
  recordsPerPage: 5
};

const ancptMarginSlice = createSlice({
  name: "ancptMargin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchAncptMarginData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchAncptMarginData.fulfilled, (state, action) => {
        const payload = action.payload;
        const { _department: department, departmentId } = action.meta.arg;
        state.status = "idle";

        if (!payload?.data?.length) {
          state.data = null;
          return;
        }

        const data = payload.data.map((item: any) => ({
          lastYear: stringToNumber(item.lastYear ?? "0"),
          currentYear: stringToNumber(item.currentYear ?? "0"),
          goal: stringToNumber(item.goal ?? "0"),
          department:
            item?.department === "Total" ? "All Dept" : item?.department?.name,
          id: item?.department?.id || ""
        }));

        state.data = filterByDepartment(data, department, departmentId);
      })
      .addCase(fetchAncptMarginData.rejected, (state) => {
        state.status = "error";
        state.data = null;
      });
  }
});

export const selectData = ({
  ancptMargin
}: {
  ancptMargin: BarChartsInitialState;
}) => ancptMargin.data;

export const selectStatus = ({
  ancptMargin
}: {
  ancptMargin: BarChartsInitialState;
}) => ancptMargin.status;

export default ancptMarginSlice.reducer;
